// eslint-disable-next-line import/no-unresolved
import ApiSearchResponse from 'prismic-javascript/types/ApiSearchResponse'

export const prismicHomePageContent: ApiSearchResponse = {
  page: 1,
  results_per_page: 20,
  results_size: 2,
  total_results_size: 2,
  total_pages: 1,
  next_page: 'null',
  prev_page: 'null',
  results: [
    {
      id: 'Xvyn1REAACMAsLcN',
      uid: 'null',
      type: 'home_page_updates',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvyn1REAACMAsLcN%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-07-01T15:12:26+0000',
      last_publication_date: '2021-01-06T15:49:47+0000',
      slugs: ['africa-rainfall-project-makes-plans-for-data-storing-and-sharing', 'this-is-how-a-global-community-unites-to-find-cancer-biomarkers.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        body: [
          {
            primary: {
              subject: 'Research update from the MCM team (September 2023)',
              summary: 'Additional ovarian work units starting September 25th.',
              date: '2023-09-22',
              image: {
                url: '/images/prismic/mcm_fullbodied_update.png',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=802',
            },
          },
          {
            primary: {
              subject: 'MCM team update: ADH6',
              summary: 'ADH6, a gene associated with smoking status and lung cancer prognosis.',
              date: '2023-09-15',
              image: {
                url: 'https://lh3.googleusercontent.com/Z1AU5eM8N2_ACVRVGQReqsVZo7RWosqOv_OotcKHEpihtYkufMIDRofc-_L4G9RJzHrO4NJG19MUljjzZ6_c3DW5zA3isJHuBbbd-MluYgHmEw4HElDhfcqpi3CEh_aMFj-pA7gZ5uWQdZOylDhPSD0',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=800',
            },
          },
          {
            primary: {
              subject: 'Update: July 25 system outage and defective OPNG work units',
              summary:
                'System outage experienced due to scheduled maintenance is now complete. We are aware of problems with OPNG work units and are investigating this issue.',
              date: '2023-07-27',
              image: {
                url: '/images/prismic/maintenanceRack.jpg',
              },
              link: 'https://www.worldcommunitygrid.org/about_us/article.s?articleId=799',
            },
          },
        ],
      },
    },
    {
      id: 'Xvu1qxEAACMArIvY',
      uid: 'null',
      type: 'home_page_hero',
      href: 'https://world-community-grid.cdn.prismic.io/api/v2/documents/search?ref=X_XcGxEAACMAsRlP&q=%5B%5B%3Ad+%3D+at%28document.id%2C+%22Xvu1qxEAACMArIvY%22%29+%5D%5D',
      tags: [],
      first_publication_date: '2020-06-30T22:02:11+0000',
      last_publication_date: '2021-01-05T19:32:17+0000',
      slugs: ['home--world-community-grid', 'kevin--home--world-community-grid', 'aids-is-constantly-evolving.so-are-the-tools-to-fight-it.'],
      lang: 'en-us',
      alternate_languages: [],
      data: {
        page_title: 'Home | World Community Grid',
        page_description:
          'World Community Grid enables anyone with a computer or Android device to donate their unused computing power to advance cutting-edge scientific research on topics related to health and sustainability.',
        social_image: '/images/logo_images/wcg_logo_square_new_200x200.png',
        background_image: {
          url: '/images/prismic/transitionBig.jpg',
        },
        headline: [
          {
            type: 'paragraph',
            text: 'Celebrating 19 years of World Community Grid',
            spans: [],
          },
          {
            type: 'paragraph',
            text: '',
            spans: [],
          },
        ],
        summary: 'Accelerating science by creating a supercomputer empowered by a global community of volunteers.',
        text_color: 'White',
        image_overlay_style: 'None',
        body: [
          {
            slice_type: 'learn_more',
            primary: {
              link: 'https://www.worldcommunitygrid.org/about_us/viewNewsArticle.do?articleId=757',
            },
          },
          /* prettier-ignore */
          /* This enables the "join" a project button on the home page, uncomment to add it back
          {
            slice_type: 'contribute_link',
            primary: {
              project_short_name: 'opn1',
            },
          },*/
        ],
      },
    },
  ],
}
